var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { enrollmentType as enrollmentTypes } from "../const/enrollmentConsts";
var getButtonType = function (buttonName) {
    return buttonName === "left" ? "ghost" : "primary";
};
export var getElectronicDetails = function () {
    return {
        title: "modal.unenrollPaperConfirm.title",
        enrollment: enrollmentTypes.PAPER,
        leftButton: {
            label: "modal.unenrollPaperConfirm.buttonLeavePaper",
            analytics: "leave paper on",
            name: "left",
            buttonType: getButtonType("left"),
        },
        rightButton: {
            label: "modal.unenrollPaperConfirm.buttonTurnPaperOff",
            analytics: "turn paper off",
            name: "right",
            buttonType: getButtonType("right"),
        },
    };
};
export var getPaperDetails = function () {
    return {
        title: "modal.unenrollConfirm.title",
        enrollment: enrollmentTypes.ELECTRONIC,
        leftButton: {
            label: "modal.unenrollConfirm.buttonLeavePaperless",
            analytics: "leave paperless statements on",
            name: "left",
            buttonType: getButtonType("left"),
        },
        rightButton: {
            label: "modal.unenrollConfirm.buttonDoNotLeavePaperless",
            analytics: "turn paperless statements off",
            name: "right",
            buttonType: getButtonType("right"),
        },
    };
};
export var getElectronicAndPaperDetails = function () {
    return {
        title: "modal.paperStatements.title",
        enrollment: enrollmentTypes.ELECTRONIC_AND_PAPER,
        leftButton: {
            label: "modal.paperStatements.mailPaper",
            analytics: "yes mail paper statements",
            name: "left",
            buttonType: getButtonType("left"),
        },
        rightButton: {
            label: "modal.paperStatements.stayPaperless",
            analytics: "no stay paperless",
            name: "right",
            buttonType: getButtonType("right"),
        },
    };
};
var getEnrollmentDetails = function (availableEnrollmentType, messageLetter) {
    var commonProps = {
        text: "modal.paperLanguage.".concat(messageLetter, ".text"),
    };
    switch (availableEnrollmentType) {
        case "ELECTRONIC":
            return __assign(__assign({}, getElectronicDetails()), commonProps);
        case "PAPER":
            return __assign(__assign({}, getPaperDetails()), commonProps);
        case "ELECTRONIC_AND_PAPER":
            return __assign(__assign({}, getElectronicAndPaperDetails()), commonProps);
        default:
            throw new Error("Unhandled enrollment type");
    }
};
export default getEnrollmentDetails;
